import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Layout from 'components/Layout'
import LibraryComponent from 'components/Library'

/**
 * Library page.
 * @Routes( /library )
 */
const Library = () => {
  const { t } = useTranslation()

  return (
    <Layout
      loggedIn
      title={t('Library.PageTitle')}
      mobileTopBar={{ centerTitle: t('Library.PageTitle') }}
    >
      <Helmet />
      <main className="library">
        <div
          style={{ paddingBottom: '4em' }}
          className="container-fluid hide-scroll-bar"
        >
          <LibraryComponent />
        </div>
      </main>
    </Layout>
  )
}

export default Library
